import React, {
    useCallback, useEffect, useMemo, useContext
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import { InputField, DropdownSelectField, Button } from '@jutro/legacy/components';
import { accessibilityAddTableRow, focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';
import styles from './TrailerComponent.module.scss';
import metadata from './TrailerComponent.metadata.json5';
import messages from './TrailerComponent.messages'; 

function TrailerComponent(props) {

    const {
        data: TrailerVM,
        updateWizardData,
        submissionVM,
        TrailerPath,
        boatInformationPath,
        id: trailerId
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    const addTrailer = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            TrailerVM.value = TrailerVM.value || []

            const { _xCenter, _dtoName } = TrailerVM;

            const TrailerObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            TrailerObjVM.isValidationReq = true;
            TrailerObjVM.yeaFie = (_.get(submissionVM, boatInformationPath))?.value?.yeaFie;
            TrailerObjVM.formaiboaortenFie = { code: "MaiBoa", name: "Main Boat"}

            TrailerVM.pushElement(
                TrailerObjVM
            );
            updateWizardData(submissionVM);

            accessibilityAddTableRow('Trailer');
            setTimeout(() => {
                focusNextElement(true,0, `${trailerId}yeaFie`);
            }, 3000);            
        },
        [TrailerVM, viewModelService, submissionVM, boatInformationPath, updateWizardData]
    );

    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            const removedTrailer = TrailerVM.value[index];

            TrailerVM.value.splice(index, 1);
            _.set(submissionVM.value, TrailerPath, TrailerVM.value);
            updateWizardData(submissionVM);
            screenReaderAnnounce(translator(messages.removeTrailer, {manDesc: removedTrailer.manFie}))
            focusNextElement(true, 0, `addTrailerButtonId`); 
        }, [submissionVM, updateWizardData, TrailerPath, TrailerVM?.value]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                const tempTrailerPath = 'lobData.recMarLine.coverables.boats[0].additionalParts.trailerTable'
                const auxiliaryArray = _.get(submissionVM.value, tempTrailerPath);
                const newNumber = auxiliaryArray?.length >= 2 ? auxiliaryArray[auxiliaryArray.length - 2].numFie + 1 : index + 1;

                if (auxiliaryArray[index].numFie === undefined) {
                    auxiliaryArray[index].numFie = newNumber;
                    _.set(submissionVM.value, tempTrailerPath, TrailerVM.value);
                }

                const value = item.numFie ? item.numFie : newNumber;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'yeaFie') {
                const value = item.yeaFie ? item.yeaFie : (_.get(submissionVM, boatInformationPath))?.value?.yeaFie;

                return (
                    <InputField
                        id={index + trailerId+ path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            const filteredVal = String(val).replace(/[^0-9]/g, ''); // keep only digits

                            item.yeaFie = filteredVal;
                            handleValueChange(filteredVal, changedPath, index);
                        }}
                        value={value}
                        maxLength="4"
                    />
                );
            }

            if (path === 'manFie') {
                const value = item.manFie ? item.manFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.manFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'serNumFie') {
                const value = item.serNumFie ? item.serNumFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            const filteredVal = String(val).replace(/[^0-9]/g, ''); // keep only digits

                            item.serNumFie = filteredVal;
                            handleValueChange(filteredVal, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'valFie') {
                const value = item.valFie ? item.valFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            const sanitized = String(val)
                                .replace(/[^0-9.]/g, '') // remove all but digits and dots
                                .replace(/^([^.]*\.)|\./g, '$1'); // allow only one dot

                            item.valFie = sanitized;
                            handleValueChange(sanitized, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'formaiboaortenFie') {

                // eslint-disable-next-line security/detect-object-injection
                const availableValues = TrailerVM.length > 0 && TrailerVM.children[index].formaiboaortenFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? TrailerVM.children[index].formaiboaortenFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                const value = (item && item.formaiboaortenFie) ? item.formaiboaortenFie : availableValues.filter((availableValue) => availableValue.code === 'MaiBoa')[0];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.formaiboaortenFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

        }, [submissionVM.value, TrailerVM.value, TrailerVM.length, TrailerVM.children, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem, translator]
    );

     const renderAddButton = useCallback(() => (
        <Button type='button' id='addTrailerButtonId' aria-label ={translator(messages.addTrailer)} onClick={(e) => addTrailer(e)}>
                {translator(messages.add)}
            </Button>
    ), [addTrailer, translator]);

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TrailerTable`]: {
            data: TrailerVM.value,
        },
         'addTrailerbtnDiv': {
            content: renderAddButton()
        }

    }), [TrailerVM.value, renderAddButton])

    const resolvers = {
        resolveCallbackMap: {
            addTrailer,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            TrailerVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [TrailerVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={TrailerVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TrailerComponent.propTypes = wizardProps;
export default withRouter(TrailerComponent);
